module.exports = __webpack_public_path__ + "img/Simulation-Gutters.69f22afe.jpeg";